__webpack_require__.p = "https://cdn.xsolla.net/xsolla-babka/v-2026-05-08/";